import { Link } from "react-router-dom";

const features = [
  { icon: "ri-discuss-line", title: "评论区互动", desc: "每篇书评下都有热闹的评论区，随时发表你的观点与追更心得。" },
  { icon: "ri-group-2-line", title: "粉丝圈子", desc: "同好聚集地，一起嗑CP、聊剧情、吐槽名场面，找到懂你的人。" },
  { icon: "ri-heart-add-line", title: "安利墙", desc: "把你心中的宝藏漫画安利给更多人，也看看大家在推什么。" },
  { icon: "ri-search-line", title: "推荐互助", desc: "说出你的偏好，书评人和其他同好会热心为你推荐合适的作品。" },
];

const highlights = [
  { icon: "ri-flashlight-line", title: "今日热议", value: "1,286 条讨论", to: "/category/xuanyi" },
  { icon: "ri-heart-pulse-line", title: "本周安利", value: "345 部", to: "/category/gaoxiao" },
  { icon: "ri-user-heart-line", title: "新增同好", value: "+2,400 人", to: "/about" },
];

export default function Community() {
  return (
    <section className="relative w-full overflow-hidden" aria-label="粉丝圈子">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20manga%20background%20with%20abstract%20chat%20bubbles%20and%20community%20icons%2C%20warm%20terracotta%20and%20amber%20color%20palette%2C%20soft%20bokeh%2C%20graphic%20comic%20style%2C%20subtle%20dark%20overlay%20for%20text%20readability&width=1600&height=800&seq=home-community-2026&orientation=landscape"
          alt="漫画岛粉丝圈子同好互动背景"
          title="漫画岛粉丝圈子"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/30 to-black/35"></div>
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <span className="flex items-center gap-2 text-sm font-medium text-accent-400">
            <i className="ri-community-line" aria-hidden="true"></i> 粉丝圈子 · 安利墙
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-3xl">同好聚集，随时互动</h2>
          <p className="mt-3 text-sm leading-relaxed text-background-100 md:text-base">
            看完漫画来聊剧情、求推荐、找同好一起追更。评论区、粉丝圈子、书评交流推荐互助，安利墙随时等你来聊。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f) => (
            <div key={f.title} className="rounded-lg border border-background-50/20 bg-background-50/10 p-5 backdrop-blur">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500/90 text-xl text-background-50">
                <i className={f.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-background-50">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {highlights.map((h) => (
            <Link
              key={h.title}
              to={h.to}
              className="group flex items-center gap-4 rounded-lg border border-background-50/20 bg-background-50/10 p-4 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500/90 text-xl text-background-50">
                <i className={h.icon} aria-hidden="true"></i>
              </span>
              <div>
                <p className="text-xs text-background-100">{h.title}</p>
                <p className="mt-0.5 font-heading text-lg font-bold text-accent-400">{h.value}</p>
              </div>
              <i className="ri-arrow-right-line ml-auto text-background-100/70 transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}